import { blue } from '@material-ui/core/colors';

export default () => ({
  root: {},
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
});
